import { render } from "./EditOriginModal.vue?vue&type=template&id=0918d228"
import script from "./EditOriginModal.vue?vue&type=script&lang=js"
export * from "./EditOriginModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__